import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import Input from '../../components/Input/Input';
import ShiftsForm from './ShiftsForm';

const styles = theme => ({
  category: {
    marginBottom: theme.spacing(6),
  },
  vertical: {
    border: 'none',
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '100%',
    width: '1px',
  },
});

const RotationForm = ({ classes, values, handleChange }) => {
  const categoryFields = [
    {
      elementType: 'select',
      config: {
        name: 'category',
        label: 'Categoria de tempo',
        options: [
          { value: 'DAYS', displayValue: 'Dias' },
          { value: 'HOURS', displayValue: 'Horas' },
        ],
      },
      helperText: 'Tipo de intervalo para a escala',
    },
    {
      elementType: 'input',
      config: {
        type: 'number',
        name: 'amountWork',
        label: values.category === 'DAYS' ? 'Dias de trabalho' : 'Horas de trabalho',
        inputProps: { min: '1' },
      },
      helperText:
        values.category === 'DAYS' ? 'Total de dias trabalhados' : 'Total de horas trabalhadas',
    },
    {
      elementType: 'input',
      config: {
        type: 'number',
        name: 'amountLoose',
        label: values.category === 'DAYS' ? 'Dias de folga' : 'Horas de folga',
        inputProps: { min: '1' },
      },
      helperText: values.category === 'DAYS' ? 'Total de dias folgados' : 'Total de horas folgadas',
    },
  ];

  return (
    <React.Fragment>
      <Grid container justify="space-between" className={classes.category}>
        {categoryFields.map((field, index) => (
          <React.Fragment key={field.config.name}>
            <Grid item xs={12} md={3}>
              <Input
                {...field.config}
                elementType={field.elementType}
                value={values[field.config.name]}
                onChange={handleChange(field.config.name)}
                required
                fullWidth
                helperText={field.helperText}
              />
            </Grid>
            {index !== categoryFields.length - 1 ? (
              <Hidden xsDown>
                <Grid item xs hidden={{ smDown: true }}>
                  <hr className={classes.vertical} />
                </Grid>
              </Hidden>
            ) : null}
          </React.Fragment>
        ))}
      </Grid>

      <ShiftsForm values={values} handleChange={handleChange} />
    </React.Fragment>
  );
};

RotationForm.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.shape({
    category: PropTypes.oneOf(['DAYS', 'HOURS']).isRequired,
    amountWork: PropTypes.string.isRequired,
    amountLoose: PropTypes.string.isRequired,
    firstShiftIni: PropTypes.string.isRequired,
    firstShiftEnd: PropTypes.string.isRequired,
    secondShiftIni: PropTypes.string,
    secondShiftEnd: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(RotationForm);
